import { SiteInfo } from "./types";

// 站点信息：品牌、公司主体、页脚链接与版权信息集中在此处配置
export const site: SiteInfo = {
  name: "同城信息门户",
  slogan: "全新信息发布体验，快速达成交易",
  company: "长沙希芽科技有限公司",
  supportEmail: "woshimi@911tech.cn",
  heroTitle: "分类信息 · 便捷生活服务",
  heroSubtitle: "房屋租售 · 二手转让 · 车辆买卖 · 生活服务，一站式信息浏览平台",
  legalNote:
    "依据《电子商务法》第十条，信息发布者以可查询的市场主体名义发布；个人自产农副产品、家庭手工业、个人技能劳务及零星小额交易除外。",
  safetyNote: "温馨提示：请自行辨别信息真伪，谨防诈骗。",
  menus: [
    { text: "首页", name: "XiyouHome" },
    { text: "信息门户", name: "XiyouPortal" },
    { text: "信息发布", name: "XiyouPublish" },
    { text: "收费规则", name: "XiyouFees" },
    { text: "信息审核机制", name: "XiyouReviewMechanism" },
  ],
  footerColumns: [
    {
      title: "联系方式",
      lines: [
        "微信公众号：woshimi_app（我是谜App）",
        "客服邮箱：woshimi@911tech.cn",
        "商务合作：微信号lxxbani",
      ],
    },
    { title: "扫码关注", qrcode: true },
  ],
  agreements: [
    {
      text: "《用户协议》",
      href: "https://woshimihtml.xiyacs.com/terms/6.html",
    },
    {
      text: "《隐私政策》",
      href: "https://woshimihtml.xiyacs.com/terms/4.html",
    },
    {
      text: "《自动续费服务规则》",
      href: "https://meitu.xiyacs.com/server_rules",
    },
  ],
  qrcodeImage: "/image/home/扫码关注@2x.png",
  copyright: "copyright2021 长沙希芽科技有限公司",
  icp: "湘ICP备2021015519号",
  license: "增值电信业务经营许可证 湘B2-20220011",
  address: "湖南湘江新区麓谷街道麓云路268号金悦雅苑二期14号楼A区2402",
};
